import {
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { cpfMask } from "cross-cutting/masks/cpf";
import { IAddress } from "models/address/IAddress";
import {
  IOwnerAddressPaymentGuest,
  IOwnerPaymentGuest,
} from "models/paymentGuest/IPaymentGuestForm";
import NewAddressForm from "pages/newAddress/NewAddressForm";
import React, { ChangeEvent, FC, useCallback, useEffect, useMemo, useState } from "react";
import { cnpjMask } from "utils/mask/cnpj";
import styles from "./ApplePayForm.module.scss";
import FindAddressPaymentLink from "pages/payment/deliverySelect/findAddressPaymentLink/FindAddressPaymentLink";
import { ArrowRight } from "@material-ui/icons";
import PickerDate from "pages/public/schedule/components/pickerDate/PickerDate";
import Input from "pages/public/schedule/components/input/Input";

export interface IApplePayForm {
  formRef: React.RefObject<HTMLDivElement>;
  errors: any;
  owner: IOwnerPaymentGuest;
  setOwner: React.Dispatch<React.SetStateAction<IOwnerPaymentGuest>>;
  address: IOwnerAddressPaymentGuest;
  setAddress: React.Dispatch<React.SetStateAction<IOwnerAddressPaymentGuest>>;
}

const ApplePayForm: FC<IApplePayForm> = ({
  formRef,
  errors,
  address,
  owner,
  setAddress,
  setOwner,
}) => {
  const [holder, setHolder] = useState<string>("fisica");
  const [openAddressForm, setOpenAddressForm] = useState(false);

  const onSubmitAddress = useCallback(
    (address: IAddress) => {
      setAddress(address);
      setOpenAddressForm(false);
    },
    [setAddress]
  );

  const changeOwnerHandle = useCallback(
    (ev: ChangeEvent<HTMLInputElement>) => {
      ev.persist();
      if (ev.target.name === "document") {
        if (holder === "fisica") {
          setOwner((prev) => ({
            ...prev,
            [ev.target.name]: cpfMask(ev.target.value),
          }));
        } else {
          setOwner((prev) => ({
            ...prev,
            [ev.target.name]: cnpjMask(ev.target.value),
          }));
        }
      } else {
        setOwner((prev) => ({ ...prev, [ev.target.name]: ev.target.value }));
      }
    },
    [holder, setOwner]
  );

  const changeDateOfBirth = useCallback(
    (date: string) => {
      setOwner((prev) => ({
        ...prev,
        birthDay: date,
      }));
    },
    [setOwner]
  );

  useEffect(() => {
    setOwner((prev) => ({ ...prev, document: "" }));
    return () => {};
  }, [holder, setOwner]);

  const showAddress = useMemo(
    () =>
      address.street
        ? `${address.street}, ${address.number} - ${address.neighborhood}, ${address.city}/${address.state}`
        : null,
    [address]
  );

  const handleFocus = useCallback(() => {
    formRef?.current?.scroll({ top: 300, behavior: "smooth" });
  }, [formRef]);

  return (
    <div id={styles.ApplePayForm}>
      <Container maxWidth="xs" className={styles.container}>
        <form>
          <Grid spacing={1} alignContent="center" alignItems="center" container>
            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                fullWidth
                onChange={changeOwnerHandle}
                value={owner.name}
                helperText={errors.owner.name}
                error={!!errors.owner.name}
                name="name"
                label="Nome completo"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="pessoa"
                  name="gender1"
                  value={holder}
                  onChange={(ev, value) => setHolder(value)}
                  row
                >
                  <FormControlLabel
                    value="fisica"
                    control={<Radio color="primary" />}
                    label="CPF"
                  />
                  <FormControlLabel
                    value="juridica"
                    control={<Radio color="primary" />}
                    label="CNPJ"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                fullWidth
                onChange={changeOwnerHandle}
                value={owner.document}
                inputProps={{
                  inputMode: holder === "fisica" ? "tel" : "text",
                }}
                onFocus={handleFocus}
                helperText={errors.owner.document}
                error={!!errors.owner.document}
                name="document"
                label={`${holder === "fisica" ? "CPF" : "CNPJ"}`}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                fullWidth
                onChange={changeOwnerHandle}
                value={owner.email}
                helperText={errors.owner.email}
                error={!!errors.owner.email}
                inputProps={{
                  inputMode: "email",
                }}
                name="email"
                label="E-mail"
              />
            </Grid>

            {/*<Grid item xs={12}>
              <Input
                value={owner.birthDay}
                variant="outlined"
                className={[
                  styles.birthDay,
                  errors.owner.birthDay ? styles.inputError : "",
                ].join(" ")}
                fullWidth
                name="birthDay"
                type="date"
                inputProps={{ max: "2022-12-31" }}
                onChange={(event) => changeDateOfBirth(event.target.value)}
                label="Data de nascimento"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              {errors.owner.birthDay && (
                <span className={styles.error}>{errors.owner.birthDay}</span>
              )}
            </Grid>*/}

            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                fullWidth
                onChange={changeOwnerHandle}
                value={owner.phoneNumber}
                helperText={errors.owner.phoneNumber}
                error={!!errors.owner.phoneNumber}
                name="phoneNumber"
                label="Telefone"
              />
            </Grid>

            {/*<Grid style={{}} item xs={12} className={styles.address}>
              <div
                onClick={() => {
                  setOpenAddressForm(true);
                }}
              >
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Endereço"
                  className={styles.textField}
                  value={showAddress}
                  helperText={errors.owner.address}
                  error={!!errors.owner.address}
                  disabled
                  InputLabelProps={{
                    shrink: !!address.street,
                    style: { color: "#5f5f5f" },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <ArrowRight />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Grid>*/}
          </Grid>
        </form>
      </Container>
      <Modal
        open={openAddressForm}
        onClose={() => setOpenAddressForm(false)}
        className={styles.addressContainer}
      >
        <Paper className={styles.paper}>
          <FindAddressPaymentLink
            onSubmitAddress={onSubmitAddress}
            address={address}
            setAddress={setAddress}
          />
        </Paper>
      </Modal>
    </div>
  );
};

export default ApplePayForm;

